export default {
  HOME_CONTENT: "HomeContent",
  ABOUT_CONTENT: "AboutContent",
  LOGIN_CONTENT: "LoginContent",
  LOGOUT_CONTENT: "LogoutContent",
  THANK_YOU_CONTENT: "ThankYouContent",
  USER_LIST_CONTENT: "UserListContent",
  USER_INDIVIDUAL_CREATION_CONTENT: "UserIndividualCreationContent",
  USER_INDIVIDUAL_UPDATE_CONTENT: "UserIndividualUpdateContent",
};
